<div
  class="app__styled--unordered-list app__solid--border relative p-4 rounded-lg bg-[#fffbe4] border-[#EFD74D] overflow-hidden"
  [ngClass]="{
    'min-h-[123px] h-fit': isIpadOrTabletScreenWidth,
    'min-h-[160px] pb-16': !isIpadOrTabletScreenWidth,
    'max-h-[245px]': fId == 1,
    'h-[245px] pb-0': fId != 1
  }"
  (mouseenter)="isHovering = true"
  (mouseleave)="isHovering = false"
>
  <div class="app__between--justified--content text-center text-ellipsis whitespace-nowrap overflow-hidden">
    <span class="app__form--attribute--title text-base leading-6"> {{ noteTitle }} </span>
    @if (note?.vault_user_form_note_id) {
    <button
      class="absolute right-0"
      mat-icon-button
      [matMenuTriggerFor]="menuItem"
      (click)="$event.stopPropagation()"
      [disableRipple]="true"
      [disabled]="actionDisabled"
    >
      <span class="material-icons" [ngClass]="{ 'text-[#C1C2C5]': actionDisabled }">more_vert</span>
    </button>
    }
    <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before">
      <button mat-menu-item class="popup-menu-item menu-btn" (click)="editNote()">
        <span class="app__centered-item justify-start app__form--attribute--title text-[#25508e] font-normal text-sm gap-[10px]"
          ><span class="material-icons material-icons-round text-base">edit</span>Edit</span
        >
      </button>
      <button mat-menu-item class="popup-menu-item" (click)="deleteNote()">
        <span class="app__centered-item justify-start app__form--attribute--title text-[#eb5757] font-normal text-sm gap-[10px] leading-[30px]">
          <span class="material-icons material-icons-round text-base text-[#eb5757]">delete</span>Delete
        </span>
      </button>
    </mat-menu>
    @if (!note?.vault_user_form_note_id) {
    <span class="absolute top-[-2px] right-[-2px]">
      <img src="/assets/images/note-suggestion-rivan.svg" />
    </span>
    }
  </div>

  @if(!isIpadOrTabletScreenWidth){
  <hr class="app__solid--border border-[#18191c1a]" />
  }
  <div
    class="app__common--dialog--scrollbar overflow-x-hidden overflow-y-auto"
    [class]="isHovering && note?.vault_user_form_note_id ? 'max-h-[150px]' : 'max-h-[110px]'"
  >
    <span class="app__form--attribute--title text-sm font-normal leading-[18px] text-[#53565b] whitespace-normal break-words">
      @if (note?.vault_user_form_note_id) {
      <span [innerHTML]="noteContent"></span>
      } @if (!note?.vault_user_form_note_id) {
      <span> {{ noteContent }} </span>
      }
    </span>
    @if(isIpadOrTabletScreenWidth){
    <hr class="app__solid--border border-[#18191c1a] mt-[-7px]" />
    }
  </div>

  @if ((!isHovering && note?.vault_user_form_note_id) || isIpadOrTabletScreenWidth) {
  <div
    class="app__centered-item justify-start"
    [ngClass]="{
      'absolute bottom-4': !isIpadOrTabletScreenWidth
    }"
  >
    @if (!isIpadOrTabletScreenWidth) {
    <ngx-avatars
      size="32"
      src="{{ note.profile_image_url }}"
      name="{{ note?.first_name + ' ' + note?.last_name | titlecase }}"
      [round]="true"
      initialsSize="2"
      cornerRadius="100"
    ></ngx-avatars>
    <span class="app__form--attribute--title text-[12px] font-semibold leading-[21px] ml-2">
      {{ note?.first_name + ' ' + note?.last_name }}
    </span>
    } @if (note?.vault_user_form_note_id) {
    <div
      class="w-fit bg-[#fff2ab] px-4 py-1 rounded"
      [ngClass]="{
        'ml-3': !isIpadOrTabletScreenWidth
      }"
    >
      <span class="app__form--attribute--title text-[10px] leading-4 text-[#dea000]">
        {{ note.vault_user_form_note_updated_at }}
      </span>
    </div>
    }
  </div>
  } @if (isHovering && !note?.vault_user_form_note_id && !actionDisabled) {
  <div class="app__centered-item w-full h-full absolute top-0 left-0 z-10 rounded-lg bg-[#18191cba]">
    <div class="block">
      <button
        class="bg-white rounded border-none min-w-[96px] py-2 text-[#25508E] font-semibold"
        (click)="openCreateNoteModal(noteTitle, noteContent)"
      >
        Resolve
      </button>
      <br />
      <button
        class="app__solid--border border-[2px] border-[#ffffff] bg-transparent rounded min-w-[96px] py-2 text-[#FFFFFF] font-semibold mt-3"
        (click)="removeNoteSuggestion(noteTitle, noteContent)"
      >
        Remove
      </button>
    </div>
  </div>
  }
</div>
